<template>
  <div >
    <remote-check-in-result-form ref="RemoteCheckInResultForm"/>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <!-- <md-dialog-title class = "heading" v-if="mode==='UPDATE'">Appointment</md-dialog-title> -->
      <md-dialog-title class = "heading" v-if="dataForm.apptDate == null">IBS/Appointment Not Found!</md-dialog-title>
      <md-dialog-title class = "heading" v-if="dataForm.inboundStatus =='O'">Appointment</md-dialog-title>
      <md-dialog-title class = "heading" v-if="dataForm.inboundStatus =='C'">Update Check-In</md-dialog-title>
      <md-dialog-title class = "heading" v-if="dataForm.inboundStatus =='R'">Appointment Finished!</md-dialog-title>
      <md-dialog-title class = "heading" v-if="dataForm.inboundStatus =='B'">Appointment Block!!</md-dialog-title>

      <md-dialog-content >
        <form id = "top"> 
          <div class = "down">
            <tr>
              <th>IBS:</th>
              <td>{{dataForm.inboundShipment}}</td>
            </tr>
            <tr>
              <th>Appt Date:</th>
              <td>{{dataForm.apptDate}}</td>
            </tr>

            <md-field ><label class = "textlabel" for="moveInBy">Driver Name</label><md-input v-model="dataForm.moveInBy" :disabled="getDisable"/></md-field>
            <md-field ><label class = "textlabel" for="driverPh">Driver Phone</label><md-input v-model="dataForm.driverPh" :disabled="getDisable"/></md-field>
            <md-field ><label class = "textlabel" for="driverLP">License Plate</label><md-input v-model="dataForm.driverLP" :disabled="getDisable"/></md-field>
            <md-field ><label class = "textlabel" for="containerNo">Trailer Number</label><md-input v-model="dataForm.containerNo" :disabled="getDisable"/></md-field>
          </div>
        </form>

        <b-notification class = "notifySize"
                  type= "is-error"
                  v-model="notifyActiveError"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
        </b-notification>  
        <b-notification class = "notifySize"
                  type= "is-success"
                  v-model="notifyActiveSuccess"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
        </b-notification>

        <h1 class = "Statements">***** MUST READ *****</h1>
        <h1 class = "Statements">*Do not come to the warehouse until you are called to scale.</h1>
        <h1 class = "Statements">*Do not double park and block the roads while you await our call. </h1>
        <h1 class = "Statements">*Find legal parking in the area.</h1>
        <h1 class = "Statements">*Long Beach Police Department will take enforcement action against illegal parking.</h1>
        <div class = "heading">
          <callingApiCenter :paths="['/api/w/fsi/WebSaveInbound']"></callingApiCenter>
            <md-dialog-actions >
              <!-- <md-button class="custButtonForm md-raised" @click="getLocation" :disabled="getDisable"><span class="icons-center material-icons">home</span>Locattion</md-button> -->
              <md-button class="custButtonForm md-raised" @click="doSaveUser" :disabled="getDisable"><span class="icons-center material-icons">edit</span>Confirm</md-button>
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
            </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<style scoped>
@import '../../public/chrisForm.css';

form {
    min-width: 640px;
    margin: 5px;
    color: #000000;
    font-size: 24px;
  }

.heading {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: #000292;
    width: 92%;
    line-height: 2;
    font-size: 24px;
    font-family: Roboto Slab;
    margin-left: 10px;
  }

.notifySize{
  background-color: yellow;
}

.is-error{
  color: red;
}

.is-success{
  color: blue;
}

.Statements {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: rgb(255, 0, 0);
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: 0;
    text-align: left;
  }

#top {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 0px;
}
#top th{
  text-align: left;
  color: #000292
}
#top td{
  padding-left: 10px;
  padding-top: 5px;
}

</style>

<script>
  import { mapGetters } from 'vuex';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import moment from 'moment';
  import dateFormat from '../utils/dateFormat';
  import RemoteCheckInResultForm from '../components/RemoteCheckInResultForm.vue';

  const getInitialdataForm = () => ({
    mode: "APPTC",
    receivingWindows: null,
    checkIn: "R",
    username: "REMOTE",
    apptSeq: null,
    inboundSeq: null,
    inboundShipment: null,
    inboundStatus: null,
    block: null,
    apptNo: null,
    apptDate: null,
    apptDateTime: null,
    ciDate: null,
    moveInBy: null,
    driverPh: null,
    driverLP: null,
    containerNo: null,
    externalTrucker: null,


  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      notifyActiveError: false,
      notifyActiveSuccess: false,
      notifyMessage: " ",
      saveCheckInRequest:{
        receivingWindows: " ",
        checkIn: " ",
        username: " ",
        inboundShipment: " ",
        inboundStatus: " ",
        block: " ",
        apptNo: " ",
        apptDate: " ",
        apptDateTime: " ",
        ciDate: " ",
        moveInBy: " ",
        driverPh: " ",
        driverLP: " ",
        containerNo: " ",
        externalTrucker: " ",
      },
    }),
    components: {
      RemoteCheckInResultForm,
    },

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),

      getDisable() {
        this.notifyActiveError = false
        this.notifyActiveSuccess = false
        this.notifyMessage = " "
        const date = dateFormat.getLocalDateOnly(moment().toDate())
        const appToDate = dateFormat.getLocalDateOnly(this.dataForm.apptDate)
        if ( appToDate != date ) return true
        if ( appToDate == date ) return false
        if (this.dataForm.inboundShipment == null || this.dataForm.apptDate == null ) return true
        if (this.dataForm.inboundStatus == "O" || this.dataForm.inboundStatus == "C") return false
        if (this.dataForm.inboundStatus != "O" || this.dataForm.inboundStatus != "C") return true
      },
    },

    validations: {
      dataForm: {
      
      },
    },
 
    methods: {

      openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
          
          console.log(existingUser);            
            this.dataForm.mode = "APPTC"
            this.dataForm.receivingWindows = existingUser.receivingWindows
            this.dataForm.checkIn = 'R'
            this.dataForm.username = "REMOTE"
            this.dataForm.apptSeq = existingUser.apptSeq
            this.dataForm.inboundSeq = existingUser.seqNo
            this.dataForm.inboundShipment = existingUser.ibs
            this.dataForm.inboundStatus = existingUser.inboundStatus
            this.dataForm.block = existingUser.block
            this.dataForm.apptNo = existingUser.apptNo
            this.dataForm.apptDate = dateFormat.gstDT(existingUser.apptDate)
            this.dataForm.apptDateTime = existingUser.apptDate
            this.dataForm.ciDate = moment()
            this.dataForm.moveInBy = existingUser.moveInBy
            this.dataForm.driverPh = existingUser.driverPh
            this.dataForm.driverLP = existingUser.driverLP
            this.dataForm.containerNo = existingUser.containerNo
            this.dataForm.externalTrucker = existingUser.externalTrucker
        }

        this.showDialog = true;
      },

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },
      
      doSaveUser() {
        this.notifyActiveError = false
        this.notifyActiveSuccess = false
        this.notifyMessage = " "
        this.dataForm.inboundStatus = "C"

        const phonedigit = /^[0-9]{10}$/
        const driverphone = this.dataForm.driverPh    

        const appTime = this.dataForm.apptDateTime
        const appTimeObject = moment(appTime);
        const appTdiff = moment().diff(appTimeObject, 'minutes')
        const late = 30


        if (this.dataForm.moveInBy == null || this.dataForm.driverPh == null || this.dataForm.driverLP == null || this.dataForm.containerNo == null){
              this.notifyActiveError = true
              this.notifyMessage = "All fields are required for Check In!" 
        }
        else{
          if (appTdiff >  late ){
              this.notifyActiveError = true
              this.notifyMessage = "Check In Failed due to be more than 30 mins late for your Appointment! Please contact FSI (562)495-1936 for assistance!"  
          }
          else{
            if (driverphone.match(phonedigit)){
              const request = this.dataForm
              //api.post('/api/w/fsi/WebSaveInbound',request)
              newAPIPost('/api/w/fsi/WebSaveInbound',request)

              this.saveCheckInRequest.receivingWindows = this.dataForm.receivingWindows 
              this.saveCheckInRequest.checkIn = this.dataForm.checkIn
              this.saveCheckInRequest.username = this.dataForm.username
              this.saveCheckInRequest.inboundSeq = this.dataForm.inboundSeq
              this.saveCheckInRequest.inboundShipment = this.dataForm.inboundShipment
              this.saveCheckInRequest.inboundStatus = this.dataForm.inboundStatus
              this.saveCheckInRequest.block = this.dataForm.block
              this.saveCheckInRequest.apptNo = this.dataForm.apptNo
              this.saveCheckInRequest.apptDate = this.dataForm.apptDateTime
              this.saveCheckInRequest.apptDateTime = this.dataForm.apptDateTime
              this.saveCheckInRequest.ciDate = this.dataForm.ciDate
              this.saveCheckInRequest.moveInBy = this.dataForm.moveInBy
              this.saveCheckInRequest.driverPh = this.dataForm.driverPh
              this.saveCheckInRequest.driverLP = this.dataForm.driverLP
              this.saveCheckInRequest.containerNo = this.dataForm.containerNo
              this.saveCheckInRequest.externalTrucker = this.dataForm.externalTrucker

              //api.post('/api/w/sqs/send', 
              newAPIPost('/api/w/sqs/send', 
                {
                  cmd: "SAVE_CHECKIN",
                  payload: JSON.stringify(this.saveCheckInRequest)
                }
              )
              this.showDialog = false;
              this.$refs.RemoteCheckInResultForm.openDialog(request);
            }
            else{
              this.notifyActiveError = true
              this.notifyMessage = "Phone number must be 10 digits(ex.1234567890)"
            }
          }
        }            
      },

      // getLocation() {

      //   var remoteLoc = getPosition();

      //   var dist = getDistance(remoteLoc);
      //   this.notifyActiveError = true
      //         this.notifyMessage = dist;

  
      //   function getPosition() {
      //     if (window.navigator.geolocation) {
      //       var onSuccess = function(position) {
      //         return position;
      //       };
      //       function onError(error) {
      //         alert('code: '    + error.code    + '\n' + 
      //               'message: ' + error.message + '\n');
      //         this.notifyActiveError = true
      //         this.notifyMessage = "Location Not Available. Please Allow Location for Check In!" 
      //       }
      //       navigator.geolocation.getCurrentPosition(onSuccess, onError);
      //     } 
      //   };

      //   function getDistance(loc) {
      //     const latLB= 33.7856971;
      //     const lonLB= -118.2238802;
      //     const latWL= 33.7834342;
      //     const lonWL= -118.2459911;

      //     if(this.dataForm.receivingWindows = '185'){

      //       var latRM = loc.coords.latitude;
      //       var lonRM = loc.coords.longitude;
      //       return latRM;

      //     }

      //     else if(dataForm.receivingWindows = '186'){
          
      //     }
      //     else{
      //         this.notifyActiveError = true
      //         this.notifyMessage = "Receiving Window Not Found!" 
      //       return;
      //     }
      //   };

      
      // },

    },
  };
</script>
